import moment from 'moment';

moment.locale(__appConfig.lang);

export { moment };
